import { NgIf } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { HeaderComponent } from '@components/header/header.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule, Location } from '@angular/common'
import { Router } from '@angular/router';
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component';
import { LinkComponent } from '@components/link/link.component';
import { ApiService } from 'app/services/api.service';
import { ColumnConfig, ColumnFormat, TableComponent } from '@components/table/table.component';
import { TransactionData } from 'app/interfaces/transaction-data.interface';
import { PaginationComponent } from '@components/pagination/pagination.component';

@Component({
    selector: 'app-mypoints',
    templateUrl: './transactions-summary.component.html',
    styleUrl: './transactions-summary.component.scss',
    standalone: true,
    imports: [HeaderComponent, TranslateModule, NgIf, ButtonComponent, CosentinoSvgComponent, LinkComponent, CommonModule, TableComponent, PaginationComponent],
})
export class TransactionsSummaryComponent {
    public currentPage: number = 0
    public totalPages: number = 0
    transactionColumns: ColumnConfig[] = [
        { key: 'ordinationDate', header: this.translateService.instant('myrewards.date'), format: 'date' as ColumnFormat },
        { key: 'fromId', header: this.translateService.instant('myrewards.identifier') },
        { key: 'status', header: this.translateService.instant('myrewards.status') },
        { key: 'contact', header: this.translateService.instant('myrewards.employee') },
        { key: 'validityDate', header: this.translateService.instant('myrewards.expiration'), format: 'date' as ColumnFormat },
        {
            key: 'strActios',
            header: this.translateService.instant('myrewards.points'),
            format: 'points' as ColumnFormat, // Es string tipo "+100"
        },
    ]

    public transactionData: TransactionData[] = []

    constructor(private location: Location, private router: Router, private api: ApiService, private translateService: TranslateService) {}

    ngOnInit() {
        const userInfo = localStorage.getItem('weUserInfo')
        if (userInfo) {
            this.api.getPointsTransactions(this.currentPage).subscribe({
                next: (response) => {
                    this.transactionData = response.items
                    this.totalPages = response.totalPages
                },
                error: (error: any) => console.log(error),
            })
        }
    }
    onPageChange(page: number) {
        this.currentPage = page
        this.api.getPointsTransactions(page).subscribe({
            next: (response) => {
                this.transactionData = response.items
                this.totalPages = response.totalPages
            },
            error: (error: any) => console.log(error),
        })
    }
    goBack() {
        this.location.back()
    }
    goToMyPoints() {
        this.router.navigate(['/my-rewards'])
    }
}
